import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP3HighBudgetNew202604: FaireAdPerformancePeriodEntity = {
  token: "perf_p3_high_budget_new_202604",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-04-01",
  endDate: "2026-04-30",
  impressions: 14452,
  clicks: 241,
  adsSpendDollars: 1495,
  budgetDollars: 1500,
  salesDollars: 16922,
  bestEstimateRoas: 11.32,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 1,
  newCustomersAcquired: 9,
  dataAvailableAtDate: "2026-05-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
